import { PrototypeApiError } from './apiClient';

export function feedbackErrorMessage(error: unknown, fallback: string): string {
	if (!(error instanceof PrototypeApiError) || !error.body || typeof error.body !== 'object') return fallback;
	const code = (error.body as { error?: unknown }).error;
	if (code === 'idempotency_conflict') return 'This feedback may already have been received. Please check My Feedback before submitting again.';
	if (code === 'feedback_service_unavailable') return 'Feedback is temporarily unavailable. Please try again shortly.';
	return fallback;
}
